import { render, staticRenderFns } from "./StudentDetailsTab.vue?vue&type=template&id=f5b22a14&"
import script from "./StudentDetailsTab.vue?vue&type=script&lang=js&"
export * from "./StudentDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports